// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Wztt","label":"Section_label__9_Cbz","contentWrap":"Section_contentWrap__5Z0v2","footer":"Section_footer__wp9Zt","footerInner":"Section_footerInner__2Uac7"};